import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import { Alert, Button, Card, Container,Col,Row} from 'reactstrap'
import queryString from 'query-string'
import { Link } from 'react-router-dom'
import header from './../../Header/HeaderText'


class AssessPrint extends Component {

  state = {
    downloading : false 
  }
  
  saveData = (function () {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    return function (url,fileName) {
      this.setState({downloading:true})
      setTimeout(()=>{
        this.setState({downloading:false})
      },2000)
        a.href = url;
        a.download = fileName;
        a.click();
    };
}())


  render() {

    const { doc, error, isGeneratingPdf, goBack, search, isGroup } = this.props
   
    var binary = atob(doc.replace(/\s/g,''));
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }
    
    // create the blob object with content-type "application/pdf"               
    var blob = new Blob( [view], { type: "application/pdf" });
    var url = URL.createObjectURL(blob);



  
    const query = queryString.parse(search)
    let displayingStudentReports = false
    if (query.sr) {
      displayingStudentReports = true
      delete query.sr
    } else {
      query.sr = true
    }
    const link = `?${queryString.stringify(query)}`

    const isEdge = navigator.appVersion.indexOf('Edge') > -1
    
    
     var  fileName = "masteryPrep(Report).pdf" ;

    return (
      <Card style={{"borderRadius" : "8px 8px 0px 0px"}}>
      <header />
        <Card style={{"height": "70px" , "borderRadius" : "8px 8px 0px 0px",'backgroundColor':'#f0f3f5'}}>
        <div style = {{'borderRadius':'8px 8px 0px 0px', 'height':'16px' , 'backgroundColor': '#283b46'}}></div> <br />
        <Row><Col sm="12" md="12" xs="12" lg="12"><div className=" ml-3 mb-3">{'17A ACT Practice Test '}</div></Col></Row>
        </Card>
        
        <Row className="ml-3">

        <Button style={{'backgroundColor': '#00C1AB', 'width': '180px'}} className="ml-3 mt-1" onClick={goBack}>{'Return to Dashboard'}</Button>
        {isEdge &&
        <div>
          {/* <Link to={link}>
            <Button>
              {displayingStudentReports ? 'Remove Student Reports' : 'Add Student Reports'}
            </Button>
          </Link> */}
  
        {!isGeneratingPdf ? (!error && <Button style={{'width': '180px'}} className="ml-3 mt-1" onClick={()=>{this.saveData(url,fileName)}}>Download Report </Button>) :(<Button style={{'width': '180px'}} className="ml-3 mt-1"><i className="fa fa-spinner fa-lg fa-spin"></i>{' '}Generating Report...</Button>) }
        </div>
        }
        </Row>
        <Container >
        
        {/* {isGroup && !isEdge &&
          <Link to={link}>
            <Button>
              {displayingStudentReports ? 'Remove Student Reports' : 'Add Student Reports'}
            </Button>
          </Link>
        } */}

        <div className = "mt-4">
        {doc && !isGeneratingPdf && !isEdge &&
          <embed src={url}
          width="100%"
          height="675px" />
        }
        </div>
        <div style={{"textAlign":"center"}} className="mb-4">
        {!isEdge && <BeatLoader loading={isGeneratingPdf} />}
        </div>
        </Container>


        {error &&
          <Alert>
            {error === 'permission'
              ? "Sorry, you don't have permission to access this report."
              : 'Error generating report. Please try again later.'
            }
          </Alert>
        }
        
      </Card>
    )
  }
}

AssessPrint.propTypes = {
  userAssessment: PropTypes.object,
  nodes: PropTypes.object,
  doc: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  isGeneratingPdf: PropTypes.bool.isRequired,
}

export default AssessPrint


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AssessPrint.js